import { Typography,Grid2 } from '@mui/material'
import React from 'react'
import "../Contact.css"

export function ContactHeroDesktop() {
  return (
   <>
    <Grid2 className="about-header info">
      <Typography sx={{color:"#fff"}} variant="h2" >Contact Us</Typography>
      <Typography sx={{color:"#fff"}} >Connect with GBG</Typography>
    </Grid2>
   </>
  )
}

 